import React, { useContext } from 'react';
import { Result } from 'antd';

import { Context } from '../../../defaults';

const MobileUser = () => {
  const { dictionary, language } = useContext(Context);
  return (
    <Result
      status="error"
      title={`${dictionary?.NoMobileAccess[language]}`}
      subTitle={`${dictionary?.NoMobileAccessMsg[language]}`}></Result>
  );
};

export default MobileUser;
